import { Loader } from '@components/loader';
import { AuditLogsList } from '@pages/auditLogs';
import { useAuditLogsList } from '@services/global/auditLogs/list';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';

function MerchantAuditLogs() {
  const navigate = useNavigate();
  const { localId } = useParams({ from: '/u/$localId/_merchant/merchant/audit-logs/' });
  const { data, isPending, meta } = useAuditLogsList();

  if (isPending) return <Loader />;

  return (
    <AuditLogsList
      data={data}
      meta={meta}
      onRowSelect={(id) => {
        navigate({ to: '/u/$localId/merchant/audit-logs/$id', params: { localId, id } }).catch(
          (err) => console.error(err),
        );
      }}
    />
  );
}

export const Route = createFileRoute('/u/$localId/_merchant/merchant/audit-logs/')({
  component: MerchantAuditLogs,
});
